import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function MenuIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M2.5 10h15M2.5 5h15M2.5 15h15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
